module.exports = __webpack_public_path__ + "static/flags/IT-35d8794f1aa9bc8362de83a39cf6fba9.gif";